import { Descriptions, Form, Input, Modal, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";  
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";

function OtpModal({ open, handleCancel,  handleSubmit,title }) {
  const { singlePaymentObj } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);
  const { user } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [isInputEmpty, setIsInputEmpty] = useState(true);

  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);

  const [counter, setCounter] = useState({ minutes: 0, seconds: 59 });
  const [activeResend, setActiveResend] = useState(false);

  const cancatenatedString = verificationCode?.join("");

  const resendOTPEmail = async () => {
    // const res = await dispatch(
    //   saveOtp({
    //     url: `auth/send-email-otp/${forgotAcc?.usrId}`,
    //   })
    // );
    // if (res?.payload?.success) {
    //   toast.success(res.payload?.messages?.message);
    // } else {
    //   toast.error(res.payload?.messages?.message);
    // }
  };
 
  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        url: `py/verifyOtp.action?otpCode=${cancatenatedString}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res.payload?.messages?.message);
      await handleSubmit(); 
      await setIsInputEmpty(true);
      await setVerificationCode(["", "", "", ""])
      await form.resetFields();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };
  const handleInputChange = (e, index) => {
    const { value } = e.target;
    setIsInputEmpty(!value);
    if (value === "") {
      if (index > 0) {
        inputRefs[index - 1].current.focus();
      }
    } else if (index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const updatedVerificationCode = [...verificationCode];
    updatedVerificationCode[index] = value;
    setVerificationCode(updatedVerificationCode);
  };

  // const handleInputChange = (e) => {
  //   const value = e.target.value;
  //   setIsInputEmpty(!value);
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     usrFirstName: value,
  //   }));
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (counter.minutes === 0 && counter.seconds === 0) {
  //       clearInterval(interval);
  //     } else {
  //       setCounter((prevCounter) => {
  //         if (prevCounter.seconds === 0) {
  //           return { minutes: prevCounter.minutes - 1, seconds: 59 };
  //         } else {
  //           return { ...prevCounter, seconds: prevCounter.seconds - 1 };
  //         }
  //       });
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [counter]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Verification`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={750}
        maskClosable={false}
      >
        <div className="w-full h-full flex flex-col">
          <div className="lg:mt-5 heading_1  justify-center items-center">
            {title}
          </div>
          <div className="heading_5">
            We have sent an OTP to the registered phone number
          </div>

          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="lg:px-20 px-3"
            form={form}
          >
            <div className="flex items-center justify-center gap-[1.25rem] mt-[1.25rem]">
              {inputRefs?.map((ref, index) => (
                <div key={index}>
                  <input
                    ref={ref}
                    className="otp-input"
                    type="text"
                    maxLength="1"
                    value={verificationCode[index]}
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </div>
              ))}
            </div>
            

            <div className="justify-center flex items-center gap-x-2 mt-[56px] mb-[48px]">
              <div className="w-[150px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Previous
                </button>
              </div>

              <div className="w-[150px]">
                <button
                  type="submit"
                  key="submit"
                  className={`cstm-btn ${
                    isInputEmpty ? "!bg-[#D1D5DB]" : "inherit"
                  } ${isInputEmpty ? "cursor-not-allowed" : "inherit"}`}
                  disabled={isInputEmpty}
                >
                  {saving ? <Spin /> : "Transfer"}
                </button>
              </div>
            </div>

            {/* <div className="mt-[66px] flex items-center justify-center typography_p_2 gap-x-1">
                Didn’t receive OTP?
                {counter.minutes === 0 && counter.seconds === 0 ? (
                  <span
                    className="font-[600] typography_p_2 !text-[#0057E3] cursor-pointer"
                    onClick={resendOTPEmail}
                    disabled={counter.minutes > 0 && counter.seconds > 0}
                    type="primary"
                  >
                    Resend
                  </span>
                ) : (
                  <span className="font-[600] typography_p_2">
                    {" "}
                    Resend in {counter.minutes.toString().padStart(2, "0")}:
                    {counter.seconds.toString().padStart(2, "0")}
                  </span>
                )}
              </div> */}
          </Form>
        </div>
      </Modal>
    </>
  );
}

export default OtpModal;
